import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    color: '#8F8F8F',
    fontSize: theme.size.sm,
    justifyContent: 'center',
    margin: '0 2rem',
    minHeight: '17px',
    cursor: 'default',

    '& > span': {
      color: 'rgba(127,132,135, 0.5)',
      marginRight: '0.25rem'
    },

    [theme.breakpoints.down('md')]: {
      height: 'auto !important'
    }
  }
}))

export default useStyles
